import React, { FC } from "react";
import TableWrapper from "../../components/table/TableWrapper";
import requestListActionTemplate from "./Actions";
import { formatDate } from "../../utils/dateUtils";
import {
  ReplacementRequest,
  useFindAllReplacementRequestQuery
} from "../../api/refereeReplacementApi";

const columns = [
  { field: "matchName", header: "Mecz" },
  { field: "matchUrl", header: "Link do meczu", body: (row: ReplacementRequest) => <a href={row.matchUrl} target="_blank" style={{color: "black"}}>Link do meczu</a>},
  { field: "matchId", header: "Id meczu" },
  { field: "refereeFullName", header: "Sędzia" },
  { field: "replacementType", header: "Region", body: (row: ReplacementRequest) => row.replacementType === "WARSAW" ? "Warszawa" : "Radom" },
  {
    field: "createdDate",
    header: "Złożony",
    body: (row: ReplacementRequest) => row.createdDate ? formatDate(new Date(row.createdDate)) : ""
  },
  { field: "", header: "", body: requestListActionTemplate }
];

const RequestList: FC<{}> = ({}) => {
  const { data, isLoading } = useFindAllReplacementRequestQuery({ replacementStatus: "WAITING_FOR_REPLACEMENT", page: 0, size: 10000 });

  return (
    <>
      <TableWrapper
        header="Aktywne zastępstwa"
        sortField="createdDate"
        isLoading={isLoading}
        data={data?.content ?? []}
        columns={columns}
        stateKey={"request-list"}
      />
    </>
  );
};

export default RequestList;
